var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4491 4.22223H14.5513C8.08019 4.22223 4.22241 8.08001 4.22241 14.5511V29.4311C4.22241 35.92 8.08019 39.7778 14.5513 39.7778H29.4313C35.9024 39.7778 39.7602 35.92 39.7602 29.4489V14.5511C39.778 8.08001 35.9202 4.22223 29.4491 4.22223ZM32.4696 19.1022C32.4696 19.7956 31.9185 20.3467 31.2251 20.3467C30.5318 20.3467 29.9807 19.7956 29.9807 19.1022V18.7822L23.3513 25.68C23.0846 25.9467 22.7291 26.0711 22.3557 26.0356C21.9824 26 21.6446 25.8045 21.4491 25.4845L19.6357 22.7822L13.0935 29.0933C12.8446 29.3422 12.5424 29.4489 12.2224 29.4489C11.9024 29.4489 11.5824 29.3245 11.3513 29.0933C10.8713 28.6133 10.8713 27.8311 11.3513 27.3333L18.9602 19.9556C19.2269 19.6889 19.5824 19.5645 19.9557 19.6C20.3291 19.6356 20.6669 19.8311 20.8624 20.1511L22.6757 22.8533L28.2207 17.04H27.9007C27.2074 17.04 26.6562 16.4889 26.6562 15.7956C26.6562 15.1022 27.2074 14.5511 27.9007 14.5511H31.2074C31.3674 14.5511 31.5274 14.5867 31.6874 14.64C31.9896 14.7645 32.2385 15.0133 32.3629 15.3156C32.434 15.4756 32.4518 15.6356 32.4518 15.7956V19.1022H32.4696Z",
    fill: "#6C84F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank);
export default __webpack_public_path__ + "static/media/rank.c2247189f8763e5d6929556eb63d771f.svg";
export { ForwardRef as ReactComponent };